__turbopack_context__.v({
  "className": "bsHsJa_className",
  "variable": "bsHsJa_variable",
});
